import VueTypes from 'vue-types'

export default {
  /**
   * 验证项的分组名称
   */
  group: VueTypes.string.def(''),
  /**
   * 验证项的名称
   */
  field: VueTypes.string.isRequired,
  /**
   * 激活验证的方式
   */
  trigger: VueTypes.array.def(['input', 'blur']),
  /**
   * 是否启用验证功能
   */
  validity: VueTypes.bool.def(false),
  /**
   * 验证项的值
   */
  value: VueTypes.oneOfType([String, Number, Array, Object, Boolean]).def(''),
  /**
   * 验证规则
   */
  rule: VueTypes.oneOfType([String, Array]).def(''),
  /**
   * 自定义验证规则
   */
  customRule: VueTypes.object.def({}),
  /**
   * input 延时验证
   */
  delay: VueTypes.number.def(500)
}
